import KFStandard from "../../KFDetail/KFStandard/KFStandard.vue";
import KostenMixin from "../Mixins/KostenMixin";

// @vue/component
export default {
  name: "HonorarKosten",
  components: {
    KFStandard,
  },
  mixins: [
    KostenMixin,
  ],
  computed: {
    betragsrechner() {
      return this.modelParameter.betragsrechner || "honorarkostenrechner";
    },

    sumLocal() {
      return this.summeCurrency;
    },
  },
};
